//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.GEpkUtils.ts                                 </Name>
//    <Description>	DB Parametry EPK													</Description>
//    <Author>      Tomáš Hažmuka														</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019									</Copyright>
//    <Created>     2019-04-04															</Created>
//  </FileHeader>

namespace Gordic.Epk.WebControls {

    //#region *** ENUMS ***

    /** barvy colorpickeru */
    export enum UzoEnum {
        /** Bílá*/
        White = "0",
        /**Červená*/
        Red = "1",
        /**Zelená*/
        Green = "2",
        /**Modrá*/
        Blue = "3",
        /**Fialová*/
        Purple = "4",
        /**Žlutá*/
        Yellow = "5",
    }

    export enum EpkZavisleEnum {
        Ne = "1",
        Ano = "0"
    }

    /** enum datumový filtr */
    export enum DatFiltrZobEnum {
        Ne = 0,
        Ano = 1,
        AnoPouzeUVyrizenych = 2
    }

    /** enum - nastavení datumů na filterpanelu */
	export enum PrehledEpkEnum {
		Celkem,
		MladsiNezMesic,
		MladsiNezTyden,
		MladsiNezDen,
		NevyrizenoPred,
		NevyrizenoTesnePred,
		NevyrizenoPo
	}

    /** enum - jestli dojde k refreshi při odcházení z detailu */
	export enum RefreshDetailEnum {
		Ne = 0,
		Ano = 1
    }

    /** validační enum stavů hromadného vyřízení */
    export enum validHromVyrizEnum {
        /** Výběr obsahuje záznamy, které lze vyřídit */
        Uspech = 0,
        /** Prázdný seznam */
        NeuspechPrazdnyGrid = 1,
        /** Nevalidní záznamů z důvodu aktivit !== 100 */
        NeuspechNevalidniZaznamy = 2
    }

    export enum EpkTerminEnum {
        /** před termínem */
        Pred = 1,
        /** těsně před termínem */
        TesnePred = 2,
        /** po termínu */
        Po = 3,
        /** vykreslit cely seznam */
        CelySeznam = 10,
        /** neberu termíny v potaz */
        Cokoliv = 99
    }

    //#endregion

    //#region *** INTERFACE ***

    /** interface počítadla textu coveru */
    export interface IOperationCoverValue {
        /** typ požadavku */
        typ_pozad_pod?: Gordic.Wfl.Interface.TypPozadavkuEpk | number | null,
        /** indetifikátor dokumentu ixp */
        ixp: string,
        /** text aktuálního progresu */
        progressText: string,
        /** počet úspěšných vyřízených dokumentů */
        success: number,
        /** počet neúspěšně vyřízených dokumentů */
        fail: number,
        /** zbývá dokumentů k vyřízení */
        remains: number
    }
    /** interface počítadla coveru */
    export interface IOperationCoverCounter {
        /** celkový počet kroků */
        total?: number,
        /** aktuální číslo progressu */
        progress: number
    }

    export interface IResultHromadVyrizeni {
        fail: number,
        success: number
    }

    /**
     * Výsledné dto podepsaných souborů
     * */
    export interface EpkVyrizeniResultDto {

        externalSignatureGuid?: string;
        externalTimestampGuid?: string;

        /**
         * Chybova hláška
         * @type {string}
         */
        reason?: string;
        /**
         * Príznak chyby
         * @type {boolean}
         */
        success?: boolean;
        /**
         * Guid souboru
         * @type {string}
         */
        guid: string;
		/**
		 * Název souboru
		 * @type {string}
		 */
        fileName: string;
		/**
		 * Identifikátor verze
		 * @type {string}
		 */
        IxsUlo: string,
		/**
		 * IsConverted
		 * @type {boolean}
		 */
        IsConverted: boolean,
		/**
		 * IsSigned
		 * @type {boolean}
		 */
        IsSigned: boolean

    }

    export interface IVyrizSouborDto {
        Ixp: string | null,
        Guid: string | null,
        Filename: string | null,
        TxtTitulek: string | null,
        TxtPopis: string | null
    }

    export interface InputVyriztDto {
        /** jedná se vyřízení s gridu? (či s detailu) */
        isGrid: boolean,
        /** zadat důvod vyřízení skrz dialogové okno? */
        selectVyrizeniTxt: boolean,
        vyrizeniTxt: string,
        zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum,
        typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk,
        ixp: string,
        serCislo: number,
        //certInfo?: CertInfo
    }

    /**
	 * subtask - badge
	 */
	export type EpkSubtask = {
        badge: {
            /** pro seznam Vlastni zadosti */
            nevyrizeno,
            /** pro seznam Vlastni zadosti */
            vyrizeno,
            /** pro seznam Vlastni zadosti */
            vraceno,
            schvalitVyrizeniSpisu,
            pridelit, 
            predat,
            rozhodnout,
            splnit
			vzitnavedomi,
			posoudit,
			schvalit,
			podepsatschvalit,
			podepsat,
			vse
		}
	}

    /** informace o souboru, který připojujeme při vyřízení */
    export class EpkFileInfo {
        /** identifikator souboru - muze byt int - interni a ext - externi */
        public guid: string
        /** nazev souboru*/
        public filename: string
        /** titulek */
        public title: string
        /** popisek */
        public description: string
        constructor() {
            this.guid = "";
            this.description = "";
            this.title = "";
            this.filename = "";
        }
    }

    /** model **/
    export type EpkModel = {
        DateInterval: {
            start: Date,
            end: Date
        },
        TypSeznamu: Wfl.Interface.TypSeznamuEpk,
        TypZadostiFilter: any,
        EpkPlus: number,
        /** EPK - Zobrazovat datumový filtr v seznamech EPK */
        DateIntervalVisible: DatFiltrZobEnum,
        ZpusVyrizRadio: boolean,
        /** využito u vlastních záznamů */
        Vyrizeno: boolean
    }

    export enum EpkValidateRowEnum {
        /** prázdný seznam */
        empty = 99,
        /** jeden řádek */
        one = 1,
        /** multi výběr */
        multi = 2,
    }

    export interface IEpkDetailOpt {
        /** hodnota stavu*/
        state: EpkValidateRowEnum,
        /** data řádku */
        row?: Gordic.Wfl.Interface.GPodpisovaKnihaDto
    }

	//#endregion

    //#region *** FUNCTIONS ***

    export function loadFromUserSettings(userSettings: Data.IGStorage, key: string) {
        if (userSettings != null) {
            return userSettings.get(key);
        }
        return null;
    }

    export function saveToUserSettings(userSettings: Data.IGStorage, key: string, value) {
        if (userSettings != null) {
            userSettings.set(key, value);
            return true;
        }
        return null;
    }


    /**
	 * Změna stavu tlačítka na statusbaru(enabled, checked).
	 * Funkce se hodí na detail.
	 * @param {JQuery<HTMLElement>} element element tlačítka
	 * @param {boolean} checked je zaškrtnuto?
	 * @param {any} enabled (default = true as boolean) je povoleno?
	 */
	export function changeButtonOnStatusBar(element: JQuery<HTMLElement>, checked: boolean, enabled = true as boolean) {
		// odstranění předešlého nastavení
		if (element.hasClass("epk_statusbar_checked")) {
			element.removeClass("epk_statusbar_checked");
		}
		if (checked) {
			element.addClass("epk_statusbar_checked");
		}
		if (enabled === false) {
			element.addClass("epk_statusbar_disabled");
		}
	}

    /**
     * nastavit prázdný panel souhrnu
     */
    function setPreviewEmpty(element: JQuery<HTMLElement>) {
        //RC 32000333 : Souhrn není k dispozici.
        $("<div class='epk-nahled-sidebar-class'>").text("jres:32000333").appendTo(element); //RC 32000333 : Souhrn není k dispozici.
    }

    /**
     * setnutí panelu Souhrnu do pravého sidebaru (seznam, detail)
     * @param element element
     * @param row data řádku
     */
    export function setPanelSouhrn(element: JQuery<HTMLElement>, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null) {

        /** gcontent souhrnu */
        var souhrnGContent = new GContent("Gordic.Epk.WebControls.Panel.Souhrn", element);

        souhrnGContent.beginOperation();

        // vyčištěné elementu
        element.empty();

        if (row == null || row.ixp == null) {
            setPreviewEmpty(element);
            souhrnGContent.endOperation();
            return;
        }
        else {

            var form = $("<div>").appendTo(element);
            var Form = new Gordic.Forms.Form({
                name: "FormPreview",
                tabLabel: "Preview",
                layoutDescriptor: "L1M1S1, L-4-8-0, M-4-8-0, S-12-12-0, breaks-300-400"
            });

            //#region ** sloupce **

            var priorita = setPriorita(row);

            Form
                .addSection("jres:26265013") //RC 26265013 : Požadavek
                
            //width: 11rem;
            //margin - left: 2rem;
            //padding - right: 2rem;

            Form
                .addRow({
                    label: "jres:32000310",         //RC 32000310 : Priorita
                    layoutDescriptor: "w-S-0-12-0"
                })
                .addText(priorita.text, priorita.customClass)

            Form
                .addRow({
                    label: "jres:26265013", //RC 26265013 : Požadavek
                    layoutDescriptor: "w-S-0-12-0"
                }) 
                .addField("gstringbox", { name: "typ_poz_txt", initialValue: row.typ_poz_txt, customClass: "bold" })

                .addRow("jres:32000042") //RC 32000042 : Upřesnění
                .addField("gstringbox", { name: "typ_pozad_pod_txt", initialValue: row.typ_pozad_pod_txt, customClass: "bold" })

                .addRow("jres:32000922") //RC 32000922 : Vyřizovatel
                .addField("gstringbox", { name: "fun_komu_rf", initialValue: row.fun_komu_rf })

                .addRow("jres:26265011") //RC 26265011 : Žadatel
                .addField("gstringbox", { name: "ixs_zmp_od_nazevrf", initialValue: row.ixs_zmp_od_nazevrf })
                .addRow("jres:26265015") //RC 26265015 : Datum požadavku
                .addField("gdatebox", { name: "dat_pozad", initialValue: row.dat_pozad })
                .addRow("jres:32000090") //RC 32000090 : Termín
                .addField("gdatebox", { name: "dat_vyriz_plan", initialValue: row.dat_vyriz_plan, customClass: "bold" })
                .addRow("jres:32000262") //RC 32000262 : Důvod vyřízení
                .addField("gstringbox", { name: "vyrizeni_txt", initialValue: row.vyrizeni_txt, customClass: "bold" })
            
            Form
                .addSection("jres:32000366") //RC 32000366 : Dokument

                .addRow("jres:26265010") //RC 26265010 : Věc
                .addField("gstringbox", { name: "vec", initialValue: row.vec, customClass: "bold" })
                //RC 32000761 : ČJ.
                //RC 32000006 : Zn.
                .addRow("jres:32000761 | jres:32000006")  
                .addField("gstringbox", { name: "cj", initialValue: row.cj })
                .addRow("jres:32000370") //RC 32000370 : Sp.Zn.
                .addField("gstringbox", { name: "cj_spis", initialValue: row.cj_spis })
                .addRow("jres:32000275") //RC 32000275 : Identifikátor
                .addField("gstringbox", { name: "ixp", initialValue: row.ixp })
                .addRow("jres:26265029") //RC 26265029 : Typ dokumentu
                .addField("gstringbox", { name: "nazev_typ", initialValue: row.nazev_typ })
                .addRow("jres:32000371") //RC 32000371 : Agenda
                .addField("gstringbox", { name: "typ_ag_prim_txt", initialValue: row.typ_ag_prim_txt })


            form.gform("createFrom", Form);
            form.gform("viewMode", "view");		 //- přepnutí do view režimu.

            //#endregion

            souhrnGContent.endOperation();

        }

       
    }

     /** nastavení priority */
    export function setPriorita(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
        var data = { text: "", customClass: "", icon: "" }
        var priorita = row.priorita;
        if (priorita === 0)
            data = { text: "jres:32000311", customClass: "g-state-background g-state-info", icon: "" }; //RC 32000311 : Nízká priorita
        else if (priorita === 1) 
            data = { text: "jres:32000312", customClass: "g-state-background g-state-warning", icon: "fa-exclamation" }; //RC 32000312 : Střední priorita
        else if (priorita === 2) 
            data = { text: "jres:32000313", customClass: "g-state-background g-state-important", icon: "fa-exclamation" }; //RC 32000313 : Vysoká priorita
        else if (priorita === 3)
            data = { text: "jres:32000746", customClass: "g-state-background g-state-error", icon: "fa-exclamation" }; //RC 32000746 : Kritická priorita
        else {
            if (priorita != null) 
                data = { text: "jres:32000312", customClass: "g-state-background g-state-warning", icon: "fa-exclamation" }; //RC 32000312 : Střední priorita
        }
        data.customClass += " gbadge_epk_panel";
        return data;
    }

    export function getTypPozadPodTxtUtils(typ_pozad_pod?: Wfl.Interface.TypPozadavkuEpk | null) {
        var typ_pozad_pod_txt = "";
        switch (typ_pozad_pod) {
            case Wfl.Interface.TypPozadavkuEpk.Podepsat:
                typ_pozad_pod_txt = "jres:32000565"; //RC 32000565 : Podepsat
                break;
            case Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit:
                typ_pozad_pod_txt = "jres:32000566"; //RC 32000566 : Podepsat a schválit
                break;
            case Wfl.Interface.TypPozadavkuEpk.Schvalit:
                typ_pozad_pod_txt = "jres:32000567"; //RC 32000567 : Schválit
                break;
            case Wfl.Interface.TypPozadavkuEpk.Posoudit:
                typ_pozad_pod_txt = "jres:32000568"; //RC 32000568 : Posoudit
                break;
            case Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi:
                typ_pozad_pod_txt = "jres:32000569"; //RC 32000569 : Vzít na vědomí
                break;
            case Wfl.Interface.TypPozadavkuEpk.Splnit:
                typ_pozad_pod_txt = "jres:32000570"; //RC 32000570 : Splnit
                break;
            case Wfl.Interface.TypPozadavkuEpk.Rozhodnout:
                typ_pozad_pod_txt = "jres:32000571"; //RC 32000571 : Rozhodnout
                break;
            case Wfl.Interface.TypPozadavkuEpk.Prideleni:
                typ_pozad_pod_txt = "jres:32000653"; //RC 32000653 : Přidělit
                break;
            case Wfl.Interface.TypPozadavkuEpk.Predani:
                typ_pozad_pod_txt = "jres:32000652"; //RC 32000652 : Předat
                break;
            case Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu:
                typ_pozad_pod_txt = "jres:32000650"; //RC 32000650 : Schválit vyřízení spisu
                break;
        }
        return typ_pozad_pod_txt;
    }

    export function setSignaturePositionsConsoleLog(name: string, config: Gordic.Wfl.Interface.GWflSignCreateConfig) {
        var SignaturePositions: any = null;
        if (config.VisualSignConfig != null && config.VisualSignConfig.SignaturePositions != null) {
            SignaturePositions = config.VisualSignConfig.SignaturePositions;
        }
        console.log("%c" + name, "color: red;");
        console.log("%cSignaturePositions:", "color: blue;", SignaturePositions);
        console.log("%cSignCreateConfig:", "color: green;", config);
    }





    //#endregion

}